import {initializeSliderAccessibility} from "../slider-accessibility/slider-accessibility";
import {tns} from "tiny-slider"

const $wrapper = document.querySelector('.main-first-screen__slider-wrapper')
const $slider = $wrapper && $wrapper.querySelector('.main-first-screen__slider')

// Retain the server-rendered slide node. Fixed responsive heights allow Tiny Slider
// to measure the vertical track without downloading every slide first.
if ($slider && $slider.children.length > 1) {
    const $dots = $wrapper.querySelector('.main-first-screen__slider-dots')
    tns({
        container: $slider,
        items: 1,
        controls: false,
        nav: true,
        navContainer: $dots,
        axis: 'vertical',
        swipeAngle: false,
        speed: 400,
        startIndex: Number($wrapper.dataset.startIndex),
        lazyload: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayButton: false,
        autoplayButtonOutput: false,
        onInit: info => {
            initializeSliderAccessibility(info)
            $wrapper.classList.add('main-first-screen__slider-wrapper--ready')
            $dots.removeAttribute('aria-hidden')
        }
    })
}
